<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.number"
            :error-messages="numberErrors"
            :label="$t('qualitycheck.test.number')"
            @input="$v.item.number.$touch()"
            @blur="$v.item.number.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.refExternal"
            :error-messages="refExternalErrors"
            :label="$t('qualitycheck.test.refexternal')"
            required
            @input="$v.item.refExternal.$touch()"
            @blur="$v.item.refExternal.$touch()"
          />
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('qualitycheck.test.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.namefr"
            :error-messages="namefrErrors"
            :label="$t('qualitycheck.test.namefr')"
            required
            @input="$v.item.namefr.$touch()"
            @blur="$v.item.namefr.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.issue"
            :error-messages="issueErrors"
            :label="$t('qualitycheck.test.issue')"
            required
            @input="$v.item.issue.$touch()"
            @blur="$v.item.issue.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.issuefr"
            :error-messages="issuefrErrors"
            :label="$t('qualitycheck.test.issuefr')"
            required
            @input="$v.item.issuefr.$touch()"
            @blur="$v.item.issuefr.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-textarea
            v-model="item.comment"
            :error-messages="commentErrors"
            :label="$t('qualitycheck.test.comment')"
            auto-grow
            required
            rows="1"
            row-height="15"
            @input="$v.item.comment.$touch()"
            @blur="$v.item.comment.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-textarea
            v-model="item.commentfr"
            :error-messages="commentfrErrors"
            :label="$t('qualitycheck.test.commentfr')"
            auto-grow
            required
            rows="1"
            row-height="15"
            @input="$v.item.commentfr.$touch()"
            @blur="$v.item.commentfr.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="machineSelectItems"
            v-model="item.machine"
            :items="machineSelectItems"
            :error-messages="machineErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('qualitycheck.test.machine')"
            multiple
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialSupplySelectItems"
            v-model="item.materialSupply"
            :items="materialSupplySelectItems"
            :error-messages="materialSupplyErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('qualitycheck.test.materialsupply')"
            multiple
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="industrialComputerSelectItems"
            v-model="item.industrialComputer"
            :items="industrialComputerSelectItems"
            :error-messages="industrialComputerErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('qualitycheck.test.industrialcomputer')"
            multiple
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="toolheadSelectItems"
            v-model="item.toolhead"
            :items="toolheadSelectItems"
            :error-messages="toolheadErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('qualitycheck.test.toolhead')"
            multiple
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="softwareVersionSelectItems"
            v-model="item.softwareVersion"
            :items="softwareVersionSelectItems"
            :error-messages="softwareVersionErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('qualitycheck.test.softwareversion')"
            multiple
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="operatingSystemSelectItems"
            v-model="item.operatingSystem"
            :items="operatingSystemSelectItems"
            :error-messages="operatingSystemErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('qualitycheck.test.operatingsystem')"
            multiple
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="controlUnitSelectItems"
            v-model="item.controlUnit"
            :items="controlUnitSelectItems"
            :error-messages="controlUnitErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('qualitycheck.test.controlunit')"
            multiple
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-model="item.accessory"
            v-if="accessorySelectItems"
            :items="accessorySelectItems"
            :error-messages="accessoryErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('qualitycheck.test.accessory')"
            multiple
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-model="item.option"
            v-if="optionSelectItems"
            :items="optionSelectItems"
            :error-messages="optionErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('qualitycheck.test.option')"
            multiple
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'QualityCheckTestForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.machineGetSelectItems();
      this.materialSupplyGetSelectItems();
      this.industrialComputerGetSelectItems();
      this.softwareVersionGetSelectItems();
      this.operatingSystemGetSelectItems();
      this.toolheadGetSelectItems();
      this.controlUnitGetSelectItems();
      this.accessoryGetSelectItems();
      this.optionGetSelectItems();
  },
  data() {
    return {
        number: null,
        refExternal: null,
        name: null,
        issue: null,
        comment: null,
        machine: null,
        materialSupply: null,
        industrialComputer: null,
        softwareVersion: null,
        operatingSystem: null,
        toolhead: null,
        controlUnit: null,
        accessory: null,
        option: null,
    };
  },
  computed: {
      isLoading() {
        return (this.isLoading_machine ||
           this.isLoading_materialsupply ||
           this.isLoading_industrialcomputer ||
           this.isLoading_operatingsystem ||
           this.isLoading_softwareversion ||
           this.isLoading_toolhead ||
           this.isLoading_controlunit ||
           this.isLoading_accessory  ||
           this.isLoading_option
         );
      },
      ...mapFields('machine', {
        machineSelectItems: 'selectItems',
        isLoading_machine : 'isLoading'
      }),
      ...mapFields('materialsupply', {
        materialSupplySelectItems: 'selectItems',
        isLoading_materialsupply : 'isLoading'
      }),
      ...mapFields('industrialcomputer', {
        industrialComputerSelectItems: 'selectItems',
        isLoading_industrialcomputer : 'isLoading'
      }),
      ...mapFields('operatingsystem', {
        operatingSystemSelectItems: 'selectItems',
        isLoading_operatingsystem : 'isLoading'
      }),
      ...mapFields('softwareversion', {
        softwareVersionSelectItems: 'selectItems',
        isLoading_softwareversion : 'isLoading'
      }),
      ...mapFields('toolhead', {
        toolheadSelectItems: 'selectItems',
        isLoading_toolhead : 'isLoading'
      }),
      ...mapFields('controlunit', {
        controlUnitSelectItems: 'selectItems',
        isLoading_controlunit : 'isLoading'
      }),
      ...mapFields('accessory', {
        accessorySelectItems: 'selectItems',
        isLoading_accessory : 'isLoading'
      }),
      ...mapFields('option', {
        optionSelectItems: 'selectItems',
        isLoading_option : 'isLoading'
      }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    numberErrors() {
      const errors = [];

      if (!this.$v.item.number.$dirty) return errors;

      has(this.violations, 'number') && errors.push(this.violations.number);


      return errors;
    },
    refExternalErrors() {
      const errors = [];

      if (!this.$v.item.refExternal.$dirty) return errors;

      has(this.violations, 'refExternal') && errors.push(this.violations.refExternal);


      return errors;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    issueErrors() {
      const errors = [];

      if (!this.$v.item.issue.$dirty) return errors;

      has(this.violations, 'issue') && errors.push(this.violations.issue);

      !this.$v.item.issue.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    commentErrors() {
      const errors = [];

      if (!this.$v.item.comment.$dirty) return errors;

      has(this.violations, 'comment') && errors.push(this.violations.comment);
      !this.$v.item.comment.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    machineErrors() {
      const errors = [];

      if (!this.$v.item.machine.$dirty) return errors;

      has(this.violations, 'machine') && errors.push(this.violations.machine);


      return errors;
    },
    materialSupplyErrors() {
      const errors = [];

      if (!this.$v.item.materialSupply.$dirty) return errors;

      has(this.violations, 'materialSupply') && errors.push(this.violations.materialSupply);


      return errors;
    },
    industrialComputerErrors() {
      const errors = [];

      if (!this.$v.item.industrialComputer.$dirty) return errors;

      has(this.violations, 'industrialComputer') && errors.push(this.violations.industrialComputer);


      return errors;
    },
    operatingSystemErrors() {
      const errors = [];

      if (!this.$v.item.operatingSystem.$dirty) return errors;

      has(this.violations, 'operatingSystem') && errors.push(this.violations.operatingSystem);


      return errors;
    },
    softwareVersionErrors() {
      const errors = [];

      if (!this.$v.item.softwareVersion.$dirty) return errors;

      has(this.violations, 'softwareVersion') && errors.push(this.violations.softwareVersion);


      return errors;
    },
    toolheadErrors() {
      const errors = [];

      if (!this.$v.item.toolhead.$dirty) return errors;

      has(this.violations, 'toolhead') && errors.push(this.violations.toolhead);


      return errors;
    },
    controlUnitErrors() {
      const errors = [];

      if (!this.$v.item.controlUnit.$dirty) return errors;

      has(this.violations, 'controlUnit') && errors.push(this.violations.controlUnit);


      return errors;
    },
    accessoryErrors() {
      const errors = [];

      if (!this.$v.item.accessory.$dirty) return errors;

      has(this.violations, 'accessory') && errors.push(this.violations.accessory);


      return errors;
    },
    optionErrors() {
      const errors = [];

      if (!this.$v.item.option.$dirty) return errors;

      has(this.violations, 'option') && errors.push(this.violations.option);


      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        machineGetSelectItems: 'machine/fetchSelectItems'
      }),
      ...mapActions({
        materialSupplyGetSelectItems: 'materialsupply/fetchSelectItems'
      }),
      ...mapActions({
        industrialComputerGetSelectItems: 'industrialcomputer/fetchSelectItems'
      }),
      ...mapActions({
        operatingSystemGetSelectItems: 'operatingsystem/fetchSelectItems'
      }),
      ...mapActions({
        softwareVersionGetSelectItems: 'softwareversion/fetchSelectItems'
      }),
      ...mapActions({
        toolheadGetSelectItems: 'toolhead/fetchSelectItems'
      }),
      ...mapActions({
        controlUnitGetSelectItems: 'controlunit/fetchSelectItems'
      }),
      ...mapActions({
        accessoryGetSelectItems: 'accessory/fetchSelectItems'
      }),
      ...mapActions({
        optionGetSelectItems: 'option/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      number: {
      },
      refExternal: {

      },
      name: {
        required,
      },
      issue: {
        required,
      },
      comment: {
        required,
      },
      machine: {
      },
      materialSupply: {
      },
      industrialComputer: {
      },
      operatingSystem: {
      },
      softwareVersion: {
      },
      toolhead: {
      },
      controlUnit: {
      },
      accessory: {
      },
      option: {
      },
    }
  }
};
</script>
